export default "__VITE_ASSET__4f0f4bb7__"